export enum MockupType {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  INFO = "INFO"
}
